import { create } from 'zustand';

interface AnalysisResult {
  type: string;
  timestamp: number;
  elementCount: number;
  loadCases: number;
  displacements: number[];
  reactions: number[];
}

interface AnalysisState {
  isRunning: boolean;
  isAnalyzing: boolean;
  progress: number;
  results: any[];
  analysisResults: AnalysisResult | null;
  errors: string[];
  currentAnalysisType: string | null;
}

interface AnalysisActions {
  startAnalysis: (type: string) => void;
  stopAnalysis: () => void;
  setProgress: (progress: number) => void;
  addResult: (result: any) => void;
  addError: (error: string) => void;
  clearResults: () => void;
  runAnalysis: (type: string) => Promise<void>;
}

export const useAnalysisStore = create<AnalysisState & AnalysisActions>((set) => ({
  isRunning: false,
  isAnalyzing: false,
  progress: 0,
  results: [],
  analysisResults: null,
  errors: [],
  currentAnalysisType: null,
  
  startAnalysis: (type) => set(() => ({
    isRunning: true,
    isAnalyzing: true,
    progress: 0,
    currentAnalysisType: type,
    errors: [],
  })),
  
  stopAnalysis: () => set(() => ({
    isRunning: false,
    isAnalyzing: false,
    progress: 0,
    currentAnalysisType: null,
  })),
  
  setProgress: (progress) => set(() => ({ progress })),
  
  addResult: (result) => set((state) => ({
    results: [...state.results, result]
  })),
  
  addError: (error) => set((state) => ({
    errors: [...state.errors, error]
  })),
  
  clearResults: () => set(() => ({
    results: [],
    errors: [],
    analysisResults: null
  })),

  runAnalysis: async (type: string) => {
    set({ isRunning: true, isAnalyzing: true, currentAnalysisType: type });
    
    try {
      // Simulate analysis
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      const result: AnalysisResult = {
        type,
        timestamp: Date.now(),
        elementCount: 10,
        loadCases: 3,
        displacements: [],
        reactions: []
      };
      
      set({ 
        analysisResults: result,
        isRunning: false,
        isAnalyzing: false 
      });
    } catch (error) {
      set({ 
        isRunning: false,
        isAnalyzing: false,
        errors: [(error as Error).message]
      });
    }
  },
}));
